import React from 'react';

// Related Components
import LoadingProfile from './profile/loading';
import LoadingRoles from './roles/loading';

export default class Loading extends React.PureComponent {
  render() {
    return (
      <React.Fragment>
        <div className='fixed-width-layout margin-bottom-20'>
          <div className='action-bar'>
            <div className="action-bar-content">
              <h1 className="ellipsis">Profile</h1>
            </div>
          </div>
          <div className='full-width-content'>
            <LoadingProfile />
          </div>
        </div>
        <LoadingRoles />
      </React.Fragment>
    )
  }
}